<script setup lang="ts">
import { RouterLink } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import AppImage from '@uiKit/elements/Image.vue'
import infoIcon from '@assets/images/propertyDetail/info.svg'
import chevronForwardIcon from '@assets/images/propertyDetail/chevron-forward.svg'
import { routes } from '@app/router/routes'
import PropertyDetailSection from './PropertyDetailSection.vue'

// SUPPORT (Figma 32590:62178) — one Help Centre row into the FAQs.
</script>

<template>
  <PropertyDetailSection title="Support">
    <RouterLink :to="routes.HELP_FAQS" class="pd-support">
      <Box align="center" gap="10px" class="pd-support__row">
        <Box align="center" justify="center" class="pd-support__icon-tile">
          <AppImage :src="infoIcon" alt="" aria-hidden="true" class="pd-support__icon" />
        </Box>
        <Box direction="col" gap="1" grow>
          <Text type="heading" weight="semibold" is="span" style="line-height: 24px"
            >Help Centre</Text
          >
          <Text type="body" color="var(--p-surface-500)" is="span" style="line-height: 20px"
            >FAQs and Guides</Text
          >
        </Box>
        <AppImage :src="chevronForwardIcon" alt="" aria-hidden="true" class="pd-support__chevron" />
      </Box>
    </RouterLink>
  </PropertyDetailSection>
</template>

<style scoped>
.pd-support {
  display: block;
  text-decoration: none;
  border-radius: 10px;
}

.pd-support:focus-visible {
  outline: 2px solid var(--p-primary-500);
  outline-offset: 2px;
}

.pd-support__row {
  height: 74px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--p-surface-0);
  transition: background 0.15s ease;
}

.pd-support:hover .pd-support__row {
  background: var(--p-primary-50);
}

.pd-support__icon-tile {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--p-surface-50);
}

.pd-support__icon {
  display: block;
  width: 20px;
  height: 20px;
}

.pd-support__chevron {
  display: block;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}
</style>
